import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {PropertyOverviewAgent, Theme} from '@frontend/models';
import {PropertyService, ThemeService} from '@frontend/services';
import {Observable, tap} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AgentDataResolver {
  constructor(
    private readonly _themeService: ThemeService,
    private readonly _propertyService: PropertyService,
  ) { }

  resolve(route: ActivatedRouteSnapshot): Observable<PropertyOverviewAgent> {
    const objectId = route.paramMap.get('objectId') ?? '';

    return this._propertyService.getAgentSettings$(objectId).pipe(tap((agent) => {
      if (agent?.isRemax) {
        this._themeService.setTheme(Theme.Remax);
      }
      if (agent?.themeConfig === 'sulek') {
        this._themeService.setTheme(Theme.Sulek);
      }
      if (agent?.themeConfig === 'wohncloud') {
        this._themeService.setTheme(Theme.WohnCloud);
      }
      if (agent?.themeConfig === 'froeschl') {
        this._themeService.setTheme(Theme.Froeschl);
      }
      if (agent?.themeConfig === 'grasl') {
        this._themeService.setTheme(Theme.Grasl);
      }
      if (agent?.themeConfig === 'finova') {
        this._themeService.setTheme(Theme.Finova);
      }
      if (agent?.themeConfig === 'hagsteiner') {
        this._themeService.setTheme(Theme.Hagsteiner);
      }
      if (agent?.themeConfig === 'remax-collection') {
        this._themeService.setTheme(Theme.RemaxCollection);
      }
      if (agent?.themeConfig?.includes('remax-classic')) {
        this._themeService.setTheme(Theme.RemaxClassic);
      }
      if (agent?.themeConfig === 'edelweiss') {
        this._themeService.setTheme(Theme.Edelweiss);
      }
      if (agent?.themeConfig === 'eraImmo') {
        this._themeService.setTheme(Theme.EraImmo);
      }
      if (agent?.themeConfig === 'sonnberger') {
        this._themeService.setTheme(Theme.Sonnberger);
      }
      if (agent?.themeConfig === 'virimo') {
        this._themeService.setTheme(Theme.Virimo);
      }
      if (agent?.themeConfig === 'realwert') {
        this._themeService.setTheme(Theme.Realwert);
      }
      if (agent?.themeConfig === 'strigl') {
        this._themeService.setTheme(Theme.Strigl);
      }
      if (agent?.themeConfig === 'immobilienring') {
        this._themeService.setTheme(Theme.Immobilienring);
      }
      if (agent?.themeConfig === 'norisk') {
        this._themeService.setTheme(Theme.Norisk);
      }
      if (agent?.themeConfig === 'mayrImmo') {
        this._themeService.setTheme(Theme.MayrImmo);
      }
      if (agent?.themeConfig === 'prosch') {
        this._themeService.setTheme(Theme.Prosch);
      }
      if (agent?.themeConfig === 'ahImmobilien') {
        this._themeService.setTheme(Theme.AhImmobilien);
      }
      if (agent?.themeConfig === 'aaaaImmobilien') {
        this._themeService.setTheme(Theme.AaaaImmobilien);
      }
      if (agent?.themeConfig === 'altera') {
        this._themeService.setTheme(Theme.Altera);
      }
      if (agent?.themeConfig === 'qualis') {
        this._themeService.setTheme(Theme.Qualis);
      }
      if (agent?.themeConfig === '4immobilien') {
        this._themeService.setTheme(Theme.Immo4)
      }
      if (agent?.themeConfig === 'immobilien-melk') {
        this._themeService.setTheme(Theme.ImmobilienMelk)
      }
    }));
  }
}
